import AuctionDetails from './auctionDetails'

export default AuctionDetails
